import axios from 'axios';
import { useSetAtom } from 'jotai';
import { useRouter } from 'next/router';

import { userInfoAtom } from '@/state/user/atom';

import useUserToken from './queries/auth/useUserToken';
import useUserInfo from './queries/user/useUserInfo';

const useUpdateAccessToken = () => {
  const router = useRouter();

  const { refetch: refetchUserToken } = useUserToken({
    onSuccess: () => refetchUserInfo(),
    onError: () => router.push('/login'),
  });

  const setUserInfo = useSetAtom(userInfoAtom);

  const { refetch: refetchUserInfo } = useUserInfo({
    onSuccess(data) {
      setUserInfo(data.data.data.user);
    },
    onError: (error) => {
      if (axios.isAxiosError(error) && error.response?.data) {
        const { status } = error.response;
        if (status === 403) {
          refetchUserToken();
        }
      }
    },
    enabled: true,
  });
};

export default useUpdateAccessToken;
